/* Free gift with purchase (product page v2 + cart page).
   Tiers come from snippets/ts2-gift-config.liquid. The tier is decided by the cart total
   without gifts. Shopify automatic discounts make the chosen gift $0 at checkout; this file
   only makes sure the cart holds the right gift (one, of the earned tier, matched to the metal). */
(function () {
  // Running again (in-place product switch, pdp-v2-swap.js) first switches the previous run's handlers off.
  if (window.__ts2GiftAC) { try { window.__ts2GiftAC.abort(); } catch (e) {} }
  var GIFT_AC = window.AbortController ? (window.__ts2GiftAC = new AbortController()) : null;
  var GIFT_SIG = GIFT_AC ? { signal: GIFT_AC.signal } : false;
  function onDoc(ev, fn) { document.addEventListener(ev, fn, GIFT_SIG); }
  if (window.TS2Gift) return;
  var cfgEl = document.querySelector('[data-ts2-gift-config]');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var tiers = (CFG.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;

  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { maximumFractionDigits: 0 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function tierFor(cents) {           // cents in shop currency
    var t = null;
    tiers.forEach(function (x) { if (cents >= x.min) t = x; });
    return t;
  }
  function nextTier(cents) { return tiers.filter(function (x) { return x.min > cents && x.gifts.length; })[0] || null; }
  function giftByHandle(h) { var g = null; tiers.forEach(function (t) { t.gifts.forEach(function (x) { if (x.handle === h) g = x; }); }); return g; }
  function metalWord(s) { var m = String(s || '').toLowerCase().match(/white|yellow|rose|black|platinum/); return m ? m[0] : ''; }
  function variantFor(gift, metalText) {
    var w = metalWord(metalText);
    return gift.variants.filter(function (v) { return w && metalWord(v.title) === (w === 'platinum' ? 'white' : w); })[0] || gift.variants[0];
  }
  function isGiftLine(i) { return /free gift/i.test(i.product_type || '') || (i.properties && i.properties._free_gift); }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function qualifying(cart) {          // non-gift total, converted back to shop currency
    return Math.round(cart.items.filter(function (i) { return !isGiftLine(i); })
      .reduce(function (a, i) { return a + i.final_line_price; }, 0) / rate);
  }
  function change(key, qty) {
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
  }
  function add(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
  }
  function giftItem(gift, metalText, tier) {
    var v = variantFor(gift, metalText);
    return { id: v.id, quantity: 1, properties: { _free_gift: 'tier-' + tier.tier } };
  }

  /* make the cart hold exactly the right gift; resolves true if anything changed */
  function reconcile(preferHandle) {
    return getCart().then(function (cart) {
      var gifts = cart.items.filter(isGiftLine);
      var others = cart.items.filter(function (i) { return !isGiftLine(i); });
      var tier = tierFor(qualifying(cart));
      var allowed = tier ? tier.gifts : [];
      var ops = [];
      if (!others.length || !allowed.length) {
        gifts.forEach(function (g) { ops.push(function () { return change(g.key, 0); }); });
      } else {
        var keep = null;
        gifts.forEach(function (g) {
          var ok = allowed.some(function (a) { return a.handle === g.handle; }) && (!preferHandle || g.handle === preferHandle);
          if (ok && !keep) { keep = g; if (g.quantity !== 1) ops.push(function () { return change(g.key, 1); }); }
          else ops.push(function () { return change(g.key, 0); });
        });
        if (!keep) {
          var pick = (preferHandle && allowed.filter(function (a) { return a.handle === preferHandle; })[0]) || allowed[0];
          ops.push(function () { return add([giftItem(pick, others[0].variant_title, tier)]); });
        }
      }
      return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve()).then(function () { return ops.length > 0; });
    });
  }

  /* ---------- product page: picker under Add to Bag ---------- */
  var box = document.querySelector('[data-ts2-gift]');
  var state = { cartQual: 0, cartGift: null, price: 0, metal: '', choice: null, tier: null };
  var badge = document.querySelector('[data-ts2-giftbadge]');
  function renderBadge(total) {
    if (!badge) return;
    if (state.tier) {
      var best = state.tier.gifts.reduce(function (a, g) { return g.value > a.value ? g : a; }, state.tier.gifts[0]);
      var g0 = giftByHandle(state.choice) || best;
      badge.innerHTML = '<span class="ts2-giftbadge__ico">' + gIcon() + '</span>' +
        '<span><strong>+ Free gift</strong> worth ' + (state.tier.gifts.length > 1 ? 'up to ' + money(best.value) + ' · choose 1 of ' + state.tier.gifts.length : money(g0.value) + ' · ' + esc(g0.title)) + '</span>';
      badge.hidden = false;
    } else {
      var nt = nextTier(total);
      if (nt) { badge.innerHTML = gIcon() + '<span>Free gift on orders over ' + money(nt.min) + '</span>'; badge.hidden = false; }
      else badge.hidden = true;
    }
  }
  function renderPdp() {
    if (!box) return;
    var total = state.cartQual + Math.round(state.price / rate);
    var tier = tierFor(total);
    state.tier = tier && tier.gifts.length ? tier : null;
    if (state.tier && (!state.choice || !state.tier.gifts.some(function (g) { return g.handle === state.choice; }))) {
      state.choice = (state.cartGift && state.tier.gifts.some(function (g) { return g.handle === state.cartGift; })) ? state.cartGift : state.tier.gifts[0].handle;
    }
    renderBadge(total);
    if (!state.tier) {
      var nt = nextTier(total);
      box.innerHTML = nt ? '<div class="ts2-gift__nudge">' + gIcon() + '<span>Add ' + money(nt.min - total) + ' more to your order to get a <strong>free gift</strong> (worth up to ' + money(nt.gifts.reduce(function (a, g) { return Math.max(a, g.value); }, 0)) + ').</span></div>' + '<button type="button" class="ts2-gift__all" data-ts2-gift-all>See all gifts</button>' : '';
      box.hidden = !nt;
      return;
    }
    var gifts = state.tier.gifts;
    if (!state.choice || !gifts.some(function (g) { return g.handle === state.choice; })) {
      state.choice = (state.cartGift && gifts.some(function (g) { return g.handle === state.cartGift; })) ? state.cartGift : gifts[0].handle;
    }
    box.hidden = false;
    box.innerHTML =
      '<div class="ts2-gift__head">' + gIcon() + '<span><strong>Your free gift with this piece</strong>' + (gifts.length > 1 ? ' · choose 1' : '') + '</span></div>' +
      '<div class="ts2-gift__list' + (gifts.length > 1 ? ' is-row' : '') + '" role="radiogroup" aria-label="Free gift" style="--n:' + gifts.length + '">' + gifts.map(function (g) {
        var on = g.handle === state.choice;
        return '<button type="button" class="ts2-gift__opt' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-gift="' + esc(g.handle) + '">' +
          (g.image ? '<img src="' + esc(g.image) + '" alt="" width="56" height="56" loading="lazy">' : '') +
          '<span><span class="ts2-gift__name">' + esc(g.title) + '</span><span class="ts2-gift__val"><s>' + money(g.value) + '</s> Free' + (gifts.length > 1 ? '' : ' \u00b7 ' + esc(variantFor(g, state.metal).title)) + '</span></span></button>';
      }).join('') + '</div>' +
      (state.cartGift && state.cartGift !== state.choice ? '<div class="ts2-gift__note">This replaces the gift already in your bag.</div>' : '') +
      '<button type="button" class="ts2-gift__all" data-ts2-gift-all>See all gifts</button>';
  }
  function gIcon() { return '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h18v4H3zM5 13h14v8H5zM12 9v12M12 9c-1.5-3-5-4-5-1.5S10.5 9 12 9zm0 0c1.5-3 5-4 5-1.5S13.5 9 12 9z" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linejoin="round"/></svg>'; }
  if (badge) badge.addEventListener('click', function (e) {
    e.preventDefault(); if (!box || box.hidden) return;
    var y = box.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
  if (box) {
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gift]'); if (!b) return;
      state.choice = b.getAttribute('data-gift'); renderPdp();
      document.dispatchEvent(new CustomEvent('ts2:gift'));
    });
    getCart().then(function (cart) {
      state.cartQual = qualifying(cart);
      var g = cart.items.filter(isGiftLine)[0]; state.cartGift = g ? g.handle : null;
      renderPdp();
      document.dispatchEvent(new CustomEvent('ts2:gift'));
    }).catch(function () {});
  }

  /* ---------- "See all gifts" pop-up: every tier and its gifts ---------- */
  function tierLabel(i) {
    var t = tiers[i], nx = tiers[i + 1];
    if (!t.min) return 'Up to ' + money(nx ? nx.min - 100 : 0);
    return nx ? money(t.min) + ' – ' + money(nx.min - 100) : money(t.min) + ' and up';
  }
  var dlg = null, dlgTab = 0, dlgCents = 0;
  function openAll(currentCents) {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'ts2-giftdlg';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-close]')) { dlg.close(); return; }
        var t = e.target.closest('[data-tab]'); if (t) { dlgTab = +t.getAttribute('data-tab'); drawAll(dlgCents); }
      });
    }
    var cur = tierFor(currentCents || 0);
    var vis = tiers.filter(function (x) { return x.gifts.length; });
    dlgTab = Math.max(0, vis.indexOf(cur && cur.gifts.length ? cur : (nextTier(currentCents || 0) || vis[0])));
    dlgCents = currentCents || 0;
    drawAll(dlgCents);
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function drawAll(currentCents) {
    var cur = tierFor(currentCents == null ? 0 : currentCents);
    var vis = tiers.filter(function (x) { return x.gifts.length; });   // tiers without gifts stay hidden
    var t = vis[dlgTab] || vis[0];
    dlg.innerHTML =
      '<button type="button" class="ts2-giftdlg__x" data-close aria-label="Close">&times;</button>' +
      '<div class="ts2-giftdlg__in">' +
        '<h3>' + gIcon() + ' Free gift with every order</h3>' +
        '<p class="ts2-giftdlg__lead">Your gift depends on your bag total. One gift per order.</p>' +
        '<div class="ts2-giftdlg__tabs" role="tablist">' + vis.map(function (x, i) {
          return '<button type="button" role="tab" data-tab="' + i + '" class="' + (i === dlgTab ? 'is-on' : '') + '" aria-selected="' + (i === dlgTab) + '">' + tierLabel(tiers.indexOf(x)) + (cur === x && x.gifts.length ? '<small>Your bag</small>' : '') + '</button>';
        }).join('') + '</div>' +
        (t.gifts.length ? '<div class="ts2-giftdlg__grid">' + t.gifts.map(function (g) {
          return '<div class="ts2-giftdlg__card">' + (g.image ? '<img src="' + esc(g.image) + '" alt="" width="120" height="120" loading="lazy">' : '') +
            '<div class="ts2-gift__name">' + esc(g.title) + '</div><div class="ts2-gift__val"><s>' + money(g.value) + '</s> Free</div></div>';
        }).join('') + '</div>' + (t.gifts.length > 1 ? '<p class="ts2-giftdlg__small">Choose 1. Comes in the gold that matches your piece.</p>' : '<p class="ts2-giftdlg__small">Comes in the gold that matches your piece.</p>')
          : '<p class="ts2-giftdlg__empty">No gift at this level yet.</p>') +
        '<p class="ts2-giftdlg__terms">The gift is added to your bag automatically and shows at $0. If you return your order, please return the gift with it, or its value is deducted from the refund.</p>' +
      '</div>';
  }
  onDoc('click', function (e) {
    if (!e.target.closest('[data-ts2-gift-all]')) return;
    e.preventDefault();
    var cents = state.cartQual + Math.round((state.price || 0) / rate);
    if (bar) getCart().then(function (c) { openAll(qualifying(c)); }); else openAll(cents);
  });

  window.TS2Gift = {
    /* called by the product page on every option change */
    update: function (priceCents, metalText) { state.price = priceCents || 0; state.metal = metalText || ''; renderPdp(); },
    /* called by Add to Bag: returns the gift line to add with the piece (or null), after clearing an old gift it replaces */
    prepareAdd: function () {
      if (!state.tier || !state.choice) return Promise.resolve(null);
      var gift = giftByHandle(state.choice); if (!gift) return Promise.resolve(null);
      if (state.cartGift === state.choice) return Promise.resolve(null);
      return getCart().then(function (cart) {
        var olds = cart.items.filter(isGiftLine);
        return olds.reduce(function (p, g) { return p.then(function () { return change(g.key, 0); }); }, Promise.resolve());
      }).then(function () { return giftItem(gift, state.metal, state.tier); });
    },
    /* the gift the shopper will get with this piece: {title, value, cost} (cost in cents, 0 if unknown) */
    selected: function (priceCents, metalText) {
      if (priceCents != null) { state.price = priceCents; state.metal = metalText || state.metal; }
      var total = state.cartQual + Math.round(state.price / rate);
      var tier = tierFor(total);
      if (!tier || !tier.gifts.length) return null;
      var g = (state.choice && tier.gifts.filter(function (x) { return x.handle === state.choice; })[0]) || tier.gifts[0];
      var v = variantFor(g, state.metal);
      return { title: g.title, value: g.value, cost: v.cost || 0, variant: v.title };
    },
    reconcile: reconcile,
    tierFor: tierFor
  };

  /* Gift switched off (theme setting "Free gift with purchase is on" unchecked, so no tier has gifts):
     bags filled before the switch can still hold a gift line. Remove it once on page load and redraw the bag. */
  if (!tiers.some(function (x) { return x.gifts && x.gifts.length; })) {
    getCart().then(function (c) {
      if (!(c.items || []).some(isGiftLine)) return;
      return reconcile().then(function () { if (window.TSCart && window.TSCart.refresh) window.TSCart.refresh(); });
    }).catch(function () {});
  }

  /* ---------- cart page: keep the gift right, show it, allow switching ---------- */
  var bar = document.querySelector('[data-ts2-gift-cart]');
  if (bar) {
    var guard = 'ts2GiftReconciled';
    reconcile().then(function (changed) {
      var n = +(sessionStorage.getItem(guard) || 0);
      if (changed && n < 2) { sessionStorage.setItem(guard, n + 1); location.reload(); return; }
      sessionStorage.removeItem(guard);
      return getCart().then(function (cart) {
        var total = qualifying(cart), tier = tierFor(total);
        var g = cart.items.filter(isGiftLine)[0];
        // a ring just built in the ring builder is a brand-new product: Shopify can take up to a couple of
        // minutes before the gift discount sees it. While the earned gift still shows a price, say so,
        // re-check every 5 s (up to 3 min) and refresh as soon as it is free.
        var pending = !!(g && tier && g.final_line_price > 0);
        if (pending) {
          var since = +(sessionStorage.getItem('ts2GiftWait') || 0);
          if (!since || Date.now() - since > 600000) { since = Date.now(); sessionStorage.setItem('ts2GiftWait', String(since)); }
          if (Date.now() - since < 180000) {
            var poll = setInterval(function () {
              change(g.key, 1).then(function (r) { return r.json(); }).then(function (c2) {
                var g2 = (c2.items || []).filter(isGiftLine)[0];
                if (!g2 || g2.final_line_price === 0) { clearInterval(poll); sessionStorage.removeItem('ts2GiftWait'); location.reload(); }
                else if (Date.now() - since > 180000) clearInterval(poll);
              }).catch(function () {});
            }, 5000);
          }
        } else sessionStorage.removeItem('ts2GiftWait');
        if (g && tier && tier.gifts.length) {
          bar.innerHTML = '<div class="ts2-gift__head">' + gIcon() + '<span><strong>Your free gift:</strong> ' + esc(g.product_title.replace(/^Free Gift:\s*/, '').split(' - ')[0]) + ' (' + money(g.original_line_price) + ' value)' +
            (pending ? '<br><span class="ts2-gift__wait">Applying your free gift to your new ring. It takes a moment; this page updates by itself.</span>' : '') + '</span></div>' +
            (tier.gifts.length > 1 ? '<div class="ts2-gift__list">' + tier.gifts.map(function (x) {
              var on = x.handle === g.handle;
              return '<button type="button" class="ts2-gift__opt' + (on ? ' is-on' : '') + '" data-gift="' + esc(x.handle) + '">' + (x.image ? '<img src="' + esc(x.image) + '" alt="" width="48" height="48" loading="lazy">' : '') + '<span><span class="ts2-gift__name">' + esc(x.title) + '</span><span class="ts2-gift__val">' + (on ? 'Selected' : 'Switch to this') + '</span></span></button>';
            }).join('') + '</div>' : '') + '<button type="button" class="ts2-gift__all" data-ts2-gift-all>See all gifts</button>';
          bar.hidden = false;
        } else {
          var nt = nextTier(total);
          if (nt && cart.items.length) {
            bar.innerHTML = '<div class="ts2-gift__nudge">' + gIcon() + '<span>Add ' + money(nt.min - total) + ' more to get a <strong>free gift</strong>.</span></div>' + '<button type="button" class="ts2-gift__all" data-ts2-gift-all>See all gifts</button>';
            bar.hidden = false;
          }
        }
      });
    }).catch(function () {});
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gift]'); if (!b || b.classList.contains('is-on')) return;
      b.disabled = true;
      reconcile(b.getAttribute('data-gift')).then(function () { location.reload(); });
    });
    // after quantity changes / removals on the cart page, re-check once the page settles
    onDoc('click', function (e) {
      if (!e.target.closest('cart-remove-button, .quantity__button, [name="minus"], [name="plus"]')) return;
      setTimeout(function () { reconcile().then(function (ch) { if (ch) location.reload(); }); }, 1500);
    });
  }
})();
